import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { hasAnyPermission } from "../lib/permissions";
import { hasPlanFeature } from "../lib/planFeatures";
import { ForcePasswordChange } from "../pages/ForcePasswordChange";
import { HoardexaLoader } from "./HoardexaLoader";
import { Layout } from "./Layout";
import { PermissionDenied } from "./PermissionDenied";

export function ProtectedRoute({ children, role, permissions, planFeature }) {
  const { user, checking } = useAuth();

  if (checking) {
    return <HoardexaLoader fullscreen label="Securing your workspace" />;
  }

  if (!user) return <Navigate to="/" replace />;

  if (user.must_change_password) {
    return <ForcePasswordChange />;
  }

  if (role) {
    const allowed = Array.isArray(role) ? role : [role];
    if (!allowed.includes(user.role)) {
      return <Navigate to={user.role === "super_admin" ? "/super-admin" : "/dashboard"} replace />;
    }
  }

  if (permissions?.length && !hasAnyPermission(user, permissions)) {
    const requestedPermission = permissions[0];
    return (
      <Layout title="Permission required" subtitle="Ask your administrator for access">
        <PermissionDenied permission={requestedPermission} />
      </Layout>
    );
  }

  if (planFeature && !hasPlanFeature(user, planFeature)) {
    return (
      <Layout title="Plan upgrade required" subtitle="This feature is not included in your current plan">
        <PermissionDenied permission="plan upgrade" />
      </Layout>
    );
  }

  return children;
}
